import type { DocumentMetadataItem, EFilingDocument } from '@lds-efsp/shared-contracts';
import { validateDocumentMetadata } from '@lds-efsp/shared-contracts';

/**
 * SPEC-SOR-258-v1: whether one Upload card paints its required-metadata red
 * state — the predicate the card's "Complete all required fields above" hint
 * and border read. Moved verbatim out of DocumentsTab's render (it introduces
 * no new authority): the card routes through the SAME shared validator the
 * Next gate uses (validateTab → validateDocumentMetadata), so its carve-outs —
 * R18 self-rep FILING_ATTORNEY, the SOR-235 representation-change
 * FILING_PARTY_ADDRESS relaxation — reach both surfaces and gate and card
 * agree. `docIndex` 0 only shapes error field paths; only the error COUNT is
 * read. Exported so the card's predicate is importable by the spec witnesses.
 */
export function documentCardIncomplete(
  doc: EFilingDocument,
  metadataItems: DocumentMetadataItem[],
  selfRepPartyIds?: Set<string>,
): boolean {
  return (
    metadataItems.length > 0 &&
    validateDocumentMetadata(doc, metadataItems, 0, false, selfRepPartyIds).errors.length > 0
  );
}
